import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function Forbidden() {
  const { user, logout } = useAuth();
  return (
    <div className="center-screen">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <h1 className="serif">No access</h1>
        <p className="caption">
          The account <b>{user?.email || 'you are signed in with'}</b> is not on the
          super-admin allowlist. Ask an administrator to add your user ID.
        </p>
        <button className="btn btn-primary" onClick={() => logout()} style={{ marginTop: 18 }}>
          Sign out
        </button>
      </div>
    </div>
  );
}
